import axios from 'axios';
import config from './config';

const API_BASE_URL = `${config.API_BASE_URL}/QRCodesApi`;

// ==================== QR CODE CRUD ====================

export const fetchQRCodes = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.userId) params.append('userId', filters.userId);
  if (filters.isActive !== undefined) params.append('isActive', filters.isActive);
  if (filters.sortBy) params.append('sortBy', filters.sortBy);
  if (filters.order) params.append('order', filters.order);
  
  const response = await axios.get(`${API_BASE_URL}?${params.toString()}`);
  return response.data;
};

export const fetchQRCodeById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/${id}`);
  return response.data;
};

export const createQRCode = async (qrCodeData) => {
  const response = await axios.post(API_BASE_URL, qrCodeData);
  return response.data;
};

export const createBulkQRCodes = async (count, baseUrl = null) => {
  const response = await axios.post(`${API_BASE_URL}/bulk`, { count, baseUrl });
  return response.data;
};

export const updateQRCode = async (id, qrCodeData) => {
  const response = await axios.put(`${API_BASE_URL}/${id}`, qrCodeData);
  return response.data;
};

export const assignQRCodeToUser = async (id, userId) => {
  const response = await axios.put(`${API_BASE_URL}/${id}/assign`, { userId });
  return response.data;
};

export const deleteQRCode = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/${id}`);
  return response.data;
};

// ==================== STATISTICS ====================

export const fetchQRCodeStats = async (id, startDate = null, endDate = null) => {
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  
  const response = await axios.get(`${API_BASE_URL}/${id}/stats?${params.toString()}`);
  return response.data;
};

export const fetchUserQRStats = async (userId) => {
  const response = await axios.get(`${API_BASE_URL}/user/${userId}/stats`);
  return response.data;
};

export const incrementDownload = async (id) => {
  const response = await axios.post(`${API_BASE_URL}/${id}/download`);
  return response.data;
};

// ==================== HELPER FUNCTIONS ====================

export const generateQRImageUrl = (trackingUrl) => {
  // Using QR code API service - 400x400 for better scan quality
  return `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(trackingUrl)}`;
};

export const getTrackingUrl = (code) => {
  // Generate tracking URL from code
  return `${config.API_BASE_URL}/QRCodesApi/track?ref=${code}`;
};

export const downloadQRImage = async (qrCode) => {
  const qrImageUrl = generateQRImageUrl(qrCode.TrackingUrl);
  
  try {
    const response = await fetch(qrImageUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `QR-${qrCode.Code}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading QR code:', error);
    throw error;
  }
};

export const downloadAllQRImages = async (qrCodes) => {
  for (const qr of qrCodes) {
    try {
      await downloadQRImage(qr);
      // Small delay to avoid overwhelming the browser
      await new Promise(resolve => setTimeout(resolve, 500));
    } catch (error) {
      console.error(`Failed to download QR code ${qr.Code}:`, error);
    }
  }
};
